import { useLazyQuery } from '@apollo/client'
import { setUserInfo } from 'cache/user-profile'
import { GET_USER_PROFILE_QUERY } from 'queries/get-user-profile'
import { GetUserProfileArgs, GetUserProfileResult } from 'ts/interfaces/userProfile.interface'

export const useGetUserProfile = () => {
  const [getUserProfile] = useLazyQuery<GetUserProfileResult, GetUserProfileArgs>(
    GET_USER_PROFILE_QUERY,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        if (data?.userSecurityProfile?.securityProfile?.isPriceHubAccess) {
          setUserInfo(data)
        }
      },
    }
  )
  return { getUserProfile }
}
